module.exports = __webpack_public_path__ + "img/6.d99b6d39.png";